module.exports = __webpack_public_path__ + "static/media/1m.b1f77bd4.png";